import React, { useEffect, useState } from "react";
import Slider from "react-slick";

const VideoV1 = () => {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch("https://eventscons.com/eventbackendnew/api/clients");
        const result = await response.json();

        if (Array.isArray(result)) {
          setClients(result);
        } else if (Array.isArray(result?.data)) {
          setClients(result.data);
        } else {
          setClients([]);
        }
      } catch (error) {
        console.error("Clients API error:", error);
        setClients([]);
      }
    };

    fetchClients();
  }, []);

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1800,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="tzClientsSection">
      <style>{`
        .tzClientsSection {
          background: #000;
          padding: 30px 0;
          overflow: hidden;
        }

        .tzClientsWrap {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
        }

        .tzClientsTitleBox {
          flex: 1;
          min-width: 250px;
          padding-left: 60px;
          padding-top: 30px;
          padding-bottom: 30px;
          color: #fff;
          background: linear-gradient(90deg, #f5f5f530, #000);
        }

        .tzClientsHeading {
          font-size: 40px;
          color: #fff;
          margin-bottom: 15px;
          text-align: left;
          font-weight: 400;
        }

        .tzClientsHeading span {
          font-weight: 700;
        }

        .tzClientsLineWrap {
          display: flex;
          align-items: center;
        }

        .tzClientsLineWhite {
          width: 120px;
          height: 2px;
          background: #fff;
          margin-right: 10px;
        }

        .tzClientsLineRed {
          width: 60px;
          height: 4px;
          background: #c1121f;
        }

        .tzClientsSliderOuter {
          flex: 2;
          min-width: 300px;
          padding: 20px 30px;
        }

        .tzClientsSliderScope .slick-slider {
          width: 100%;
        }

        .tzClientsSliderScope .slick-list {
          overflow: hidden;
          margin: 0 -10px;
        }

        .tzClientsSliderScope .slick-track {
          display: flex;
          align-items: center;
        }

        .tzClientsSlide {
          padding: 10px;
        }

        .tzClientsCard {
          height: 130px;
          display: flex !important;
          align-items: center;
          justify-content: center;
          background: #fff;
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 12px;
          padding: 0px;
          transition: all 0.3s ease;
        }

        .tzClientsCard:hover {
          border-color: rgba(255, 255, 255, 0.18);
          transform: translateY(-3px);
        }

        .tzClientsImage {
          width: 100%;
          max-width: 90px;
          height: 90px;
          object-fit: contain;
          filter: grayscale(100%);
          opacity: 0.9;
          transition: all 0.3s ease;
        }

        .tzClientsCard:hover .tzClientsImage {
          filter: grayscale(0%);
          opacity: 1;
        }

        @media (max-width: 991px) {
          .tzClientsTitleBox {
            padding-left: 30px;
          }

          .tzClientsHeading {
            font-size: 32px;
          }
        }

        @media (max-width: 767px) {
          .tzClientsWrap {
            flex-direction: column;
            align-items: stretch;
          }

          .tzClientsTitleBox {
            min-width: 100%;
            padding-left: 20px;
            padding-right: 20px;
          }

          .tzClientsSliderOuter {
            width: 100%;
            padding: 20px;
          }

          .tzClientsHeading {
            font-size: 28px;
          }
        }
      `}</style>

      <div className="tzClientsWrap">
        <div className="tzClientsTitleBox">
          <h2 className="tzClientsHeading">
            Our <span>Clients</span>
          </h2>

          <div className="tzClientsLineWrap">
            <div className="tzClientsLineWhite"></div>
            <div className="tzClientsLineRed"></div>
          </div>
        </div>

        <div className="tzClientsSliderOuter">
          <div className="tzClientsSliderScope">
            <Slider {...sliderSettings}>
              {clients.map((item) => (
                <div className="tzClientsSlide" key={item.id}>
                  <div className="tzClientsCard">
                    <img
                      src={`http://techzenondev.com/event/storage/app/public/${item.image}`}
                      alt={`client-${item.id}`}
                      className="tzClientsImage"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoV1;